import { render, staticRenderFns } from "./printreturnselected.vue?vue&type=template&id=32507db6&"
import script from "./printreturnselected.vue?vue&type=script&lang=js&"
export * from "./printreturnselected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports